import React from 'react';
import { Link } from "react-router-dom";
import { RedirectToWhatsAppPage } from '../../../helpers/CommonHelper';
import whatsAppLogo from '../../resources/themeContent/images/common/whatsapp-logo.png';
import './WhatsappChatButton.css';

const WhatsappChatButton = () => {

  
    return (
           <>
           
            <Link
                to="#!"
                className="whatsapp_float whatsapp-chat-button"
                aria-label="Chat with Asuremart on WhatsApp"
                onClick={(e) => {
                    e.preventDefault();
                    RedirectToWhatsAppPage();
                }}
            >
                <span className="whatsapp-chat-button__icon">
                    <img src={whatsAppLogo} alt="" />
                    <span className="whatsapp-chat-button__online" aria-hidden="true" />
                </span>
            </Link>

           </>
    )
}

export default WhatsappChatButton;
